<template>
  <v-navigation-drawer
    v-model="open"
    class="back"
    hide-overlay
    left
    :width="open ? getSize : 0"
    disable-resize-watcher
  >
    <scroll-area>
      <template slot="header">
        <v-toolbar dark color="secondary" dense>
          <v-toolbar-title>
            <v-layout justify-start align-baseline>
              <span class="body-2 text-uppercase">{{$t('settings')}}</span>
            </v-layout>
          </v-toolbar-title>
        </v-toolbar>
      </template>

      <template slot="body">
        <v-layout column fill-height justify-start>
          <map-sidebar/>
        </v-layout>
      </template>
    </scroll-area>
  </v-navigation-drawer>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import MapSidebar from '@/nms/components/map/map-sidebar.vue'

// Типы для данных
interface TopologyBarData {
  [key: string]: any
}

export default Vue.extend({
  name: 'TOPOLOGY_BAR',

  components: {
    scrollArea,
    MapSidebar,
  },

  props: {
    open: {
      type: Boolean,
      default: () => false
    },
    size: {
      type: Number,
      default: () => 1500
    },
    data: {
      type: Object as () => TopologyBarData,
      default: () => ({})
    },
  },

  data(): {
    barOpen: boolean
    barSize: number
  } {
    return {
      barOpen: true,
      barSize: 300,
    }
  },

  computed: {
    getOpen(): boolean {
      return this.open
    },

    getSize(): number {
      return this.size
    },
  },

  created(): void {
    this.setup()
  },

  mounted(): void {
    document.addEventListener('keyup', this.closeOnESC)
  },

  beforeDestroy(): void {
    document.removeEventListener('keyup', this.closeOnESC)
  },

  methods: {
    setup(): void {},

    closeOnESC(e: KeyboardEvent): void {
      if (e.which === 27 || e.keyCode === 27) {
        e.stopPropagation()
      }
    },

    close(): void {
      this.$emit('close')
    },

    reset(): void {},
  },
})
</script>

<style lang="css" scoped>
</style>
